import React from "react";
import {useSelector, useDispatch} from "react-redux";

import loadingGif from '../../../assets/images/loader.gif';
import * as actionTypes from "../../../store/actions/actionTypes";
import bookingList from "../../../store/reducers/bookingList";
import {updateBookingStatus} from "../../../store/actions/bookingList";
import {useToasts} from "react-toast-notifications";

const ArchivedBooking = ({booking, onClose}) => {
    const dispatch = useDispatch();
    const {archivedIds} = useSelector(state => state.bookingList);
    const {addToast} = useToasts();

    const handleAction = () => {
        dispatch(updateBookingStatus(booking, addToast, 'archived'));
        if (onClose) onClose();
    }

    if(archivedIds.indexOf(booking.id) > -1) {
        return (
            <a className="dropdown-item disabled pointer"><img src={loadingGif} alt="pointer" />Archive</a>
        );
    } else {
        return (
            <a className="dropdown-item pointer" onClick={handleAction}>Archive</a>
        );
    }
}

export default ArchivedBooking;